/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MetadataItemInput } from './MetadataItemInput';
import {
    MetadataItemInputFromJSON,
    MetadataItemInputFromJSONTyped,
    MetadataItemInputToJSON,
} from './MetadataItemInput';
import type { MetadataItemPostAuthentication } from './MetadataItemPostAuthentication';
import {
    MetadataItemPostAuthenticationFromJSON,
    MetadataItemPostAuthenticationFromJSONTyped,
    MetadataItemPostAuthenticationToJSON,
} from './MetadataItemPostAuthentication';

/**
 * Provider metadata that needs to be given by the user or fetched by the connector post authentication for the connector to work.
 * @export
 * @interface ProviderMetadata1
 */
export interface ProviderMetadata1 {
    /**
     * Metadata provided as manual input
     * @type {Array<MetadataItemInput>}
     * @memberof ProviderMetadata1
     */
    input?: Array<MetadataItemInput>;
    /**
     * Metadata fetched by the connector post authentication
     * @type {Array<MetadataItemPostAuthentication>}
     * @memberof ProviderMetadata1
     */
    postAuthentication?: Array<MetadataItemPostAuthentication>;
}

/**
 * Check if a given object implements the ProviderMetadata1 interface.
 */
export function instanceOfProviderMetadata1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProviderMetadata1FromJSON(json: any): ProviderMetadata1 {
    return ProviderMetadata1FromJSONTyped(json, false);
}

export function ProviderMetadata1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderMetadata1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'input': !exists(json, 'input') ? undefined : ((json['input'] as Array<any>).map(MetadataItemInputFromJSON)),
        'postAuthentication': !exists(json, 'postAuthentication') ? undefined : ((json['postAuthentication'] as Array<any>).map(MetadataItemPostAuthenticationFromJSON)),
    };
}

export function ProviderMetadata1ToJSON(value?: ProviderMetadata1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'input': value.input === undefined ? undefined : ((value.input as Array<any>).map(MetadataItemInputToJSON)),
        'postAuthentication': value.postAuthentication === undefined ? undefined : ((value.postAuthentication as Array<any>).map(MetadataItemPostAuthenticationToJSON)),
    };
}

